import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";

import { apiPath, RoutePath } from "../../utility/Constant";

const UserCreate = () => {
  const { userAdd } = apiPath;
  const { manageUser } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "Username",
      type: "Text",
      name: "email",
      required: true,
    },
    {
      elementType: "input",
      label: "Full Name",
      type: "Text",
      name: "firstName",
      required: true,
    },
    {
      elementType: "input",
      label: "User Password",
      type: "password",
      name: "password",
      required: true,
    },
    {
      elementType: "input",
      label: "Confirm Password",
      type: "password",
      name: "confirmPassword",
      required: true,
    },
    {
      elementType: "select",
      label: "User Role",
      type: "Text",
      name: "role",
      required: true,
      options: ["admin", "moderator"],
    },
  ];

  const update = (data) => {
    updateData(userAdd, data, null, null, null, true);
    navigate(manageUser);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default UserCreate;
